mutation StartEntrypointPull($id: ID!, $sourceUrl: String!) {
  startEntrypointPull(id: $id, sourceUrl: $sourceUrl) {
    id
    pull {
      sourceUrl
      status
      attempt
      maxAttempts
      startedAt
      finishedAt
      lastError {
        code
        message
      }
    }
  }
}
